<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Add Property'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    @if (loaded) {
      <form [formGroup]="form" novalidate action="#">
        @if (isRentalClient) {
          <tidy-card>
            <tidy-card-button (action)="goToAddDirectIntegration()">
              <tidy-grid>
                <tidy-row>
                  <ion-row>
                    <ion-col size="2" class="vertical-align-center">
                      <div style="margin:auto">
                        <tidy-image
                          [src]="'assets/img/integrate.svg'"
                          style="width:45px" />
                      </div>
                    </ion-col>
                    <ion-col>
                      <tidy-row>
                        <tidy-text
                          [header]="'Integrate PMS'" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [body]="'If you use a PMS system you can integrate to import all properties.'" />
                      </tidy-row>
                    </ion-col>
                  </ion-row>
                </tidy-row>
              </tidy-grid>
            </tidy-card-button>
            <tidy-card-button (action)="goToImportCSV()">
              <tidy-grid>
                <tidy-row>
                  <ion-row>
                    <ion-col size="2" class="vertical-align-center">
                      <div style="margin:auto">
                        <tidy-image
                          [src]="'assets/img/csv.svg'"
                          style="width:30px" />
                      </div>
                    </ion-col>
                    <ion-col>
                      <tidy-row>
                        <tidy-text
                          [header]="'Import CSV'" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [body]="'Import all properties by importing a CSV.'" />
                      </tidy-row>
                    </ion-col>
                  </ion-row>
                </tidy-row>
              </tidy-grid>
            </tidy-card-button>
          </tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [helper]="'or'"
              class="divider" />
          </tidy-row>
        }
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/home.svg'"
              class="title-size" />
            @if (isRentalClient) {
              <tidy-text
                [header]="'Add One Property'" />
            }
            @if (!isRentalClient) {
              <tidy-text
                [header]="'Add Property'" />
            }
          </tidy-row>
          <tidy-row class="field-top-padding">
            <tidy-select
              [icon]="'assets/svg/location.svg'"
              [label]="'Country'"
              [items]="countryList"
              [form]="form.get('countryCode')"
              formControlName="countryCode"
              (optionChange)="changeCountrySelected($event)" />
          </tidy-row>
          <tidy-row>
            <tidy-auto-complete
              label="Address"
              formControlName="address"
              [options]="autocompleteAddress"
              [icon]="'assets/svg/home.svg'"
              [form]="form.controls.address"
              [errorMessage]="'Please enter a valid address'"
              [submitted]="submitted"
              (keyup)="updateSearch()"
              (action)="chooseItem($event)" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="address2"
              [form]="form.controls.address2"
              label="Unit / Apartment"
              [errorMessage]="'Please enter a valid unit'"
              [submitted]="submitted"
              [icon]="'assets/img/door.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="zipcode"
              [customMask]="zipCodeMask"
              [form]="form.controls.zipcode"
              [errorMessage]="'Please enter a valid zipcode'"
              [submitted]="submitted"
              [inputMode]="'numeric'"
              label="Postal Code"
              [icon]="'assets/img/mailbox.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="addressNickname"
              [form]="form.controls.addressNickname"
              [label]="'Property Nickname (optional)'"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
        </tidy-card>
        @if (radioButtonAddress.length > 0 && submitted && (typedOnAddress || !didChooseAddress)) {
          <tidy-card>
            <tidy-row>
              <tidy-text
                [header]="'Please confirm your address:'" />
            </tidy-row>
            <tidy-row>
              <tidy-radio-button
                [helper]="'If you do not see your address please retype it above'"
                [items]="radioButtonAddress"
                (optionChange)="chooseItem($event); setAddressFormControl($event)" />
            </tidy-row>
          </tidy-card>
        }
        <tidy-error-message
          [text]="errorMessage" />
        <tidy-button
          [text]="'Add Property'"
          class="primary"
          [action]="boundAddAddress" />
      </form>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
